import { format, isSaturday, isWeekend, subDays } from 'date-fns'
import React from 'react'
import { useSelector } from 'react-redux'
import { AppState, AuthenticationState } from 'web-common'
import {
    TNPageCreateAccountCTA,
    puzzleTNCreateAccountCTAProps,
} from '../../../user-registration'
import { PuzzleListingContainer } from '../../components/TheNightly/PuzzleListingContainer'
import {
    PuzzleDate,
    PuzzleLink,
    PuzzleLinkContainer,
    PuzzleTitle,
    TextContainer,
    Title,
    TitleDescription,
} from './PuzzleListing.styled'
const quickCrossword = require('./assets/quickCrossword.svg')
const miniCrossword = require('./assets/miniCrossword.svg')
const sudokuImage = require('./assets/sudoku.svg')

export const PuzzleListing = () => {
    // Get Last weekday to display.
    const now = new Date(Date.now())
    let lastWeekday = now
    if (isWeekend(now)) {
        lastWeekday = subDays(now, isSaturday(now) ? 1 : 2)
    }

    const dateString = format(lastWeekday, 'd MMM yyyy').toUpperCase()

    const { isLoggedIn, emailVerified, isLoading } = useSelector<
        AppState,
        AuthenticationState
    >((state) => state.authentication)

    // Check is entitled to view status
    const entitled = isLoggedIn && emailVerified && !isLoading

    return (
        <PuzzleListingContainer>
            <TextContainer>
                <Title>Puzzles</Title>
                <TitleDescription>New puzzles every weekday.</TitleDescription>
            </TextContainer>
            <TNPageCreateAccountCTA {...puzzleTNCreateAccountCTAProps} />

            <PuzzleLinkContainer>
                <PuzzleLink
                    to={'/puzzles/crossword'}
                    entitled={entitled}
                    aria-disabled={entitled === false || true}
                >
                    <img
                        src={quickCrossword}
                        alt={'Quick Crossword'}
                        draggable={false}
                    />
                    <PuzzleTitle>Quick crossword</PuzzleTitle>
                    <PuzzleDate>{dateString}</PuzzleDate>
                </PuzzleLink>
                <PuzzleLink
                    to={'/puzzles/mini-crossword'}
                    entitled={entitled}
                    aria-disabled={entitled === false || true}
                >
                    <img
                        src={miniCrossword}
                        alt={'Quick Crossword'}
                        draggable={false}
                    />
                    <PuzzleTitle>Mini crossword</PuzzleTitle>
                    <PuzzleDate>{dateString}</PuzzleDate>
                </PuzzleLink>
                <PuzzleLink
                    to={'/puzzles/sudoku'}
                    entitled={entitled}
                    aria-disabled={entitled === false || true}
                >
                    <img src={sudokuImage} alt={'Sudoku'} draggable={false} />
                    <PuzzleTitle>Sudoku</PuzzleTitle>
                    <PuzzleDate>{dateString}</PuzzleDate>
                </PuzzleLink>
            </PuzzleLinkContainer>
        </PuzzleListingContainer>
    )
}
